/**
 * Página principal de FACe (Factura Electrónica a Administraciones Públicas)
 */

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FaceConfig } from "@/components/FaceConfig";
import { FaceEnvios } from "@/components/FaceEnvios";
import { Settings, Send, Building2 } from "lucide-react";

export default function Face() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <Building2 className="h-8 w-8" />
          FACe - Administraciones Públicas
        </h1>
        <p className="text-muted-foreground mt-2">
          Gestiona el envío de facturas electrónicas a Administraciones Públicas a través de FACe
        </p>
      </div>

      <Tabs defaultValue="config" className="space-y-6">
        <TabsList>
          <TabsTrigger value="config" className="gap-2">
            <Settings className="h-4 w-4" />
            Configuración
          </TabsTrigger>
          <TabsTrigger value="envios" className="gap-2">
            <Send className="h-4 w-4" />
            Envíos a FACe
          </TabsTrigger>
        </TabsList>

        <TabsContent value="config">
          <FaceConfig />
        </TabsContent>

        <TabsContent value="envios">
          <FaceEnvios />
        </TabsContent>
      </Tabs>
    </div>
  );
}
